export default __webpack_public_path__ + "static/media/quikstart-1.69b2aa91.svg";